import React, { useEffect } from "react";
import { Grid, Box } from '@material-ui/core';

import myProfile from '../components/Home/myProfile.jpg'
import { styled,useTheme } from '@mui/material/styles';
import Typography from '@material-ui/core/Typography';

import MyLi from '../components/MyLi';
import MyLink from '../components/MyLink';
import AllNews from '../utility/news/AllNews';
import useMediaQuery from '@mui/material/useMediaQuery';

import twitter from '../components/Home/icon/twitter.svg';
import googleScholoar from '../components/Home/icon/google-scholar.svg';
import github from '../components/Home/icon/github-square.svg';
import linkedin from '../components/Home/icon/linkedin.svg';
import orcid from '../components/Home/icon/orcid.svg';

import { Divider } from '@mui/material';

import { Chip } from '@mui/material';

function MyIcon({iconSource, link}) {
  return (
    <a href={link} target="_blank" rel="noopener noreferrer">
        <img 
            src={iconSource} 
            alt="Icon description"
            width={24}
            height={24}
            style={{ padding: "0 10px 0 0",  }}
        />
    </a>
  );
}

function PaperLabel({link, venueType}) {
  return (
    <>  
        <Chip label={venueType} color= {venueType=="Journal"?"info":"secondary"} size="small" /> 
        &nbsp;
        {link==""?
        <></>
        :
        <Chip label="PDF" component="a" href={link} clickable color="success" target="_blank" rel="noopener noreferrer" size="small" /> 
    }
    </>
  );
}

function getComponentArray(input){

    const sortedKeys = Object.keys(AllNews)
    .sort((a, b) => b.localeCompare(a));
  
    for (const keyOfNews of sortedKeys) {
        for (var index = 0; index <= AllNews[keyOfNews].length - 1; index++) {
            var eventOfNews = AllNews[keyOfNews][index]
            input.push(
                <LatestNewsLine dateTime={eventOfNews.date} key={eventOfNews.date + keyOfNews}>
                    {eventOfNews.content}
                </LatestNewsLine>
            )
            // the number of new to display
            if(input.length>=6){
                return eventOfNews
            }
        }        
    }
}

var newsComponentArray = []
getComponentArray(newsComponentArray)


const Root = styled('Typography')(({ theme }) => ({
    padding: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
        height: "auto",
    },
    [theme.breakpoints.up('md')]: {
        height: "auto",
    },
  }));


  
  export default function Home(props) {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));

    useEffect(() => {
        document.title = "Yonghui Liu - Home"
    }, [])

    return (
        <Grid container justifyContent="center" style={{ width: "100%",  }}>
            <Grid alignItems="center" xs={12} item container style={{ maxWidth: '1344px', padding: "10px", minWidth: '350px' }}>                            
                <Grid   justifyContent="flex-start" xs={12} sm={12} md={7} item container >
                    {/* profile */}
                    <Grid justifyContent="flex-start" container item xs={5} sm={4}  md={4} style={{ height: "", padding:'0px 15px 0 0' }}>
                        <img
                            src={myProfile}
                            style={{
                                width: "100%",
                                height: "250px",
                                // position: "fixed",
                                borderRadius: "5px",
                                zIndex: "0",
                                objectFit: "cover",
                                // borderLeft: '5px solid #000', 
                            }}
                        />
                    </Grid>
                    
                    {/* personal info */}            
                    <Grid 
                    justifyContent="flex-end" xs={7} sm={6}  md={6} item
                    container direction="column" sx
                        style={{
                        width: "100%",
                        height:"250px" ,                                                        
                        // padding: "5px",                                                                           
                    }}>
                        <Grid item xs>            
                            <Box>
                                <Typography style={{textAlign: 'justify', fontSize: "15px", fontWeight: "500" }}>
                                    <b style={{ fontSize: "16px", fontFamily: 'Courier' }}>Yonghui Liu</b>
                                    {/* <br /> */}
                                    <b style={{ fontSize: "16px", fontFamily: 'Courier' }}>（刘勇辉）</b>
                                    <br />
                                    Research Fellow 
                                    {/* Research Fellow (Level-B) */}
                                    <br />
                                    School of Computing
                                    {/* <br /> */}
                                    {/* Faculty of Information Technology (FIT) */}
                                    <br />
                                    Australian National University, Australia                                                                        
                                    <br />
                                </Typography> 
                            </Box>
                        </Grid>
                        
                        <Grid item xs>
                            <Box
                            sx={{
                                height: '100%',
                                display: 'flex',
                                alignItems: 'end',
                            }}>
                                <Typography style={{textAlign: 'justify', fontSize: "15px", fontWeight: "500" }}>
                                    <b style={{ fontFamily: 'Courier' }}>Email:</b>&nbsp;                                    
                                    {/* <br /> */}
                                    {/* &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; */}
                                    <MyLink href="mailto:Yonghui.Liu@anu.edu.au" style={{fontFamily: 'Courier'}}>
                                    Yonghui.Liu@anu.edu.au
                                    </MyLink>    
                                    <br />
                                <MyIcon iconSource={twitter} link="https://x.com/DannyGooo" />
                                <MyIcon iconSource={googleScholoar} link="https://scholar.google.com/citations?user=QQoV8zwAAAAJ&hl=en&oi=sra" />
                                <MyIcon iconSource={github} link="https://github.com/DannyGooo" />
                                <MyIcon iconSource={linkedin} link="https://www.linkedin.com/in/yong-hui-liu/" />                           
                                <MyIcon iconSource={orcid} link="https://orcid.org/0000-0001-7548-5100" />                           
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>


                {/* advertisement */}
                <Grid justifyContent="flex-end" xs={12} md={5}  container>       
                    <Grid container direction="column" 
                    style={{ 
                        padding: "0px 5px", 
                        backgroundColor: "rgba(238, 238, 238, 0.5)",  
                        height: matches ? "250px" :"auto", 
                        marginLeft: matches ? "20%" :"auto",
                        borderLeft: '5px solid',
                        // borderImageSource: 'linear-gradient(5deg, transparent, darkslategray, transparent)',
                        borderImageSlice: '1',
                        width: "120%",
                    }} >

                    
                        <Grid item>
                            {/* <Box sx={{ bgcolor: 'primary.main', color: 'white', p: 2, textAlign: 'center' }}> */}
                            <Box sx={{ textAlign: 'center' }}>
                                <Typography style={{ textAlign: 'justify' }}>                                                                         
                                    <span style={{fontWeight: "600", color:"red"}}>ON ACADEMIC JOB MARKET</span>, please feel free to reach out if you know of any good opportunities!                                                                                                                                       
                                </Typography>   
                            </Box>
                        </Grid>
                        <Grid item xs>
                            <Box sx={{ flexGrow: 1 }}></Box>
                        </Grid>
                        <Grid item>
                            <Box sx={{  textAlign: 'center' }}>
                            {/* <Box sx={{ bgcolor: 'secondary.main', color: 'white', p: 2, textAlign: 'center' }}> */}
                            <Typography style={{ textAlign: 'justify' }} >
                                <span style={{fontWeight: "600"}}>                                
                                Please submit your high-quality work to  
                                </span>
                                &nbsp;
                                <MyLink href="https://pldi25.sigplan.org/">PLDI'2025</MyLink>,&nbsp;
                                <MyLink href="https://conf.researchr.org/home/icse-2025">ICSE'2025</MyLink>,&nbsp;
                                <MyLink href="https://conf.researchr.org/home/fse-2025">FSE'2025-SRC</MyLink>,&nbsp;
                                <MyLink href="https://issre.github.io/2025/index.html">ISSRE'2025</MyLink>,&nbsp;
                                <MyLink href="https://2025.msrconf.org/">MSR'2025</MyLink>,&nbsp;
                                <MyLink href="https://conf.researchr.org/home/mobilesoft-2025">MOBILESoft'2025</MyLink>,&nbsp;
                                <MyLink href="https://conf.researchr.org/home/mobilesoft-2025">MOBILESoft'2025(App)</MyLink>,&nbsp;
                                <MyLink href="https://etaps.org/about/tacas/">TACAS'2025</MyLink>,&nbsp;                                                                 
                                <MyLink href="https://llmsc.github.io/">LLMSC'2025</MyLink>,&nbsp;                                                                 
                                <MyLink href="https://llmappworkshop.github.io/">LLMapp'2025</MyLink>,&nbsp;                                                                 
                                <MyLink href="https://sites.google.com/view/quatic2025/thematic-tracks/safety-security-and-privacy?authuser=0">QUATIC'2025-SP</MyLink>,&nbsp;                                                                 
                                <MyLink href="https://ifm2025.ens.psl.eu/">ICiFM'2025</MyLink>&nbsp;                                                                 
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>                                                                 
                </Grid>

                

                {/* intruduction */}
                <Grid xs={12} item container style={{ padding: "0 0 10px 0px" }} >
                    <Typography align="justify" style={{ fontWeight: 500, fontSize: "16px" }}>
                        <span style={{fontWeight: "600"}}>Short Bio: </span>I am a level-B Research Fellow at the <MyLink href="https://www.anu.edu.au/">Australian National University (ANU). </MyLink>
                        {/* <span style={{fontWeight: "600"}}>Short Bio: </span>I am a Research Fellow at the <MyLink href="https://www.anu.edu.au/">Australian National University (ANU)</MyLink>, primarily collaborating with 
                        <MyLink href="https://zheng-lab-anu.github.io/index.html"> Prof. Liang Zheng </MyLink>
                         and <MyLink href="https://people.csiro.au/X/Z/Zhenchang-Xing/">Prof. Zhenchang Xing</MyLink>.                      */}

                        I did my Ph.D at Monash University in Australia, supervised by                         
                        <MyLink href="https://sites.google.com/site/johncgrundy/"> Prof. John Grundy</MyLink>, 
                        <MyLink href="https://lilicoding.github.io/"> Prof. Li Li</MyLink>,  <MyLink href="https://chunyang-chen.github.io/index.html"> Prof. Chunyang Chen</MyLink>, and
                        <MyLink href="https://www.newcastle.edu.au/profile/xiao-chen"> Dr. Xiao Chen</MyLink>.

                        During my doctoral studies, I visited the <MyLink href="https://trux-dtf.github.io/"> TruX research group </MyLink> at the University of Luxembourg, working with <MyLink href="https://jacquesklein2302.github.io/">Prof. Jacques Klein</MyLink>, <MyLink href="https://bissyande.github.io/">Prof. Tegawendé F. Bissyandé</MyLink>, and <MyLink href="https://www.jordansamhi.com/">Dr. Jordan Samhi</MyLink>.
                        Subsequently, I visited <MyLink href="https://soarsmu.github.io/">SOAR lab</MyLink> at the Singapore Management University, working with <MyLink href="http://www.mysmu.edu/faculty/davidlo/">Prof. David Lo</MyLink>. 
                        My academic journey at Monash began with a Bachelor (Honours) degree, followed by an M.Phil. degree at Monash with 
                        <MyLink href="https://lilicoding.github.io/"> Prof. Li Li</MyLink>, and  
                        <MyLink href="https://www.newcastle.edu.au/profile/xiao-chen"> Dr. Xiao Chen</MyLink>, 
                        which later transitioned into my PhD studies.                        

                        
                        
                        <br></br>                                                
                        <br></br>                        
                        <span style={{fontWeight: "600"}}>Research interest: </span>
                        My research lies at the intersection of Software Engineering, Artificial Intelligence, and Program Analysis, with
                        a focus on <span style={{fontWeight: "600"}}>Advancing Code Representation</span>. Building on this foundation, I am actively
                        exploring the synergistic relationship between Large Language Models (LLMs) and Mobile Software Engineering.
                        {/* investigating  */}
                        {/* <span style={{fontWeight: "600"}}> How to leverage LLMs to improve program analysis accuracy and efficiency? </span>                                                  */}
                        {/* My work, published in prestigious venues including ASE, FSE, TOSEM, and TSE, emphasizes the development of automatic, sound,
                        and accurate tools that not only facilitate software development but also contribute to broad <span style={{fontWeight: "600"}}> Software Engineering</span>, <span style={{fontWeight: "600"}}> Intelligent Software Engineering</span>, and <span style={{fontWeight: "600"}}> Software Security</span>.  */}
                        
                    </Typography>
                </Grid>

                {/* <Divider sx={{        
                    background: 'linear-gradient(5deg, transparent, darkslategray, transparent)',
                    height: '5px',
                    maxWidth: '100%',                     
                    width: "100%",
                    border: 'none'
                }} />      */}
                
                {/* news */}
                {/* <Grid  xs={12} item container style={{ padding: "0px", background:"rgba(238, 238, 238, 0.5)" }} >                
                    <Typography style={{ fontWeight: 900, fontSize: "22px", fontFamily: '' }}> News <span style={{ fontWeight: 700, fontSize: "18px" }}> (<MyLink href="/#/news">more</MyLink>) </span> </Typography>            
                    {newsComponentArray}                    
                </Grid> */}
                               

                {/* Selected publications */}
                {/* <Divider sx={{        
                    background: 'linear-gradient(5deg, transparent, darkslategray, transparent)',
                    height: '5px',
                    maxWidth: '100%',                     
                    width: "100%",
                    border: 'none'
                }} />      */}
                <Grid xs={12} item  style={{ padding: "0px " }} >                    
                    <Typography style={{ fontWeight: 900, fontSize: "22px", fontFamily: ''}}> Selected Publications <span style={{ fontWeight: 700, fontSize: "18px" }}> (See this <MyLink href="/#/publications">Full List</MyLink> page.) </span> </Typography>            
                    
                    <Typography style={{ fontWeight: 700, fontSize: "18px", paddingLeft:"0px", fontFamily: '-apple-system' }}>LLM + Program Analysis</Typography>
                    <ul style={{ padding: "0px 0 0 30px",  margin:"0px" }}>
                        <MyLi>(TOSEM 2024, Core A*) Daihang Chen, <b>Yonghui Liu</b>, Mingyi Zhou, Yanjie Zhao, Haoyu Wang, Shuai Wang, Xiao Chen, Tegawende Bissyande, Jacques Klein, and Li, Li, LLM for Mobile: An Initial Roadmap, 2024 <PaperLabel link="" venueType="Journal" /></MyLi>                                  
                        <MyLi>(TOSEM 2024, Core A*) Yue Liu, Chakkrit Tantithamthavorn, <b>Yonghui Liu</b>. and Li Li, On the Reliability and Explainability of Language Models for Program Generation, 2024 <PaperLabel link="https://arxiv.org/pdf/2302.09587" venueType="Journal" /></MyLi>                                  
                        <MyLi>(TOSEM 2024, Core A*) Yue Liu, Chakkrit Tantithamthavorn, <b>Yonghui Liu</b>, Patanamon Thongtanunam, and Li Li, Automatically Recommend Code Updates: Are We There Yet?, 2024 <PaperLabel link="https://www.researchgate.net/profile/Patanamon-Thongtanunam-2/publication/382307804_Automatically_Recommend_Code_Updates_Are_We_There_Yet/links/669daa294a172d2988b6d720/Automatically-Recommend-Code-Updates-Are-We-There-Yet.pdf" venueType="Journal" /></MyLi>                                  
                    </ul>

                    <Typography style={{ fontWeight: 700, fontSize: "18px", paddingLeft:"0px", fontFamily: '-apple-system' }}>Program Analysis for Mobile</Typography>
                    <ul style={{ padding: "0px 0 0 30px",  margin:"0px" }}>
                        <MyLi>(TOSEM 2024, Core A*) <b>Yonghui Liu</b>, Xiao Chen, Pei Liu, Jordan Samhi, Chunyang Chen, John Grundy, and Li Li, Demystifying React Native Android Apps for Static Analysis, 2024 <PaperLabel link="https://nzjohng.github.io/publications/papers/tosem2024_6.pdf" venueType="Journal" /></MyLi>
                        <MyLi>(ASE 2023, Core A*) <b>Yonghui Liu</b>, Xiao Chen, Pei Liu, John Grundy, Chunyang Chen, and Li Li, ReuNify: A Step Towards Whole Program Analysis for React Native Android App, 2023 <PaperLabel link="https://arxiv.org/pdf/2309.03524" venueType="Conference" /></MyLi>
                        <MyLi>(TSE 2023, Core A*) Xiaoyu Sun, Xiao Chen, <b>Yonghui Liu</b>, John Grundy, and Li Li, Taming Android Fragmentation through Lightweight Crowdsourced Testing, 2023 <PaperLabel link="https://arxiv.org/pdf/2304.04347" venueType="Journal" /> </MyLi>                        
                    </ul>
                </Grid>  

                {/* Teaching */}
                {/* <Divider sx={{        
                    background: 'linear-gradient(5deg, transparent, darkslategray, transparent)',
                    height: '5px',
                    maxWidth: '100%',                     
                    width: "100%",
                    border: 'none'
                }} />                    */}
                <Grid  xs={12} item  style={{ padding: "0px", background:"rgba(238, 238, 238, 0.5)" }} >                
                    <Typography style={{ fontWeight: 900, fontSize: "22px", fontFamily: '' }}> Teaching </Typography>                                                            
                    <ol style={{ padding: "0px 0 0 30px",  margin:"0px" }}>
                        <MyLi>SENG6320 - Software Verification and Validation (Master), Casual Academic. Semester 1, 2025, University of Newcastle</MyLi>                                  
                        <MyLi>SENG3320 - Software Verification and Validation (Bachelor), Casual Academic. Semester 1, 2025, University of Newcastle</MyLi>                                                          
                        <MyLi>SENG6320 - Software Verification and Validation (Master), Casual Academic. Semester 1, 2024, University of Newcastle</MyLi>                                  
                        <MyLi>SENG3320 - Software Verification and Validation (Bachelor), Casual Academic. Semester 1, 2024, University of Newcastle</MyLi>                                                          
                        <MyLi>FIT2081 - Mobile application development (Bachelor), Teaching Associate. Semester 1, 2023, Monash University</MyLi>                                  
                        <MyLi>FIT2095 - e-Business software technologies (Bachelor), Teaching Associate. Semester 1, 2023, Monash University</MyLi>                                  
                        <MyLi>FIT1047 - Introduction to Computer Systems, Networks and Security (Bachelor), Teaching Associate. Semester 1, 2023, Monash University</MyLi>                                  
                        <MyLi>FIT1047 - Introduction to Computer Systems, Networks and Security (Bachelor), Teaching Associate. Semester 2, 2022, Monash University</MyLi>                                  
                    </ol>  
                    <Typography align="justify" style={{ fontWeight: 500, fontSize: "14px" }}>
                    Teaching is a passion of mine, and I firmly believe it stands among the greatest aspects—if not the absolute pinnacle—of academic life.
                    </Typography>
                </Grid>  

                {/* funding management */}
                {/* <Divider sx={{        
                    background: 'linear-gradient(5deg, transparent, darkslategray, transparent)',
                    height: '5px',
                    maxWidth: '100%',                     
                    width: "100%",
                    border: 'none'
                }} />                   */}
                <Grid  xs={12} item  style={{ padding: "0px", 
                    // background:"rgba(238, 238, 238, 0.5)"
                }} >                
                    <Typography style={{ fontWeight: 900, fontSize: "22px", fontFamily: 'Courier' }}> Funding / Grant Projects</Typography>                    
                        <Typography style={{ fontWeight: 700, fontSize: "18px", paddingLeft:"0px", fontFamily: '-apple-system' }}>Group Projects</Typography>
                        <ul style={{ padding: "0px 0 0 30px",  margin:"0px" }}>
                            <MyLi>Associate Investigator (AI), A$598,381.24 by Department of Health and Aged Care (Australia), <MyLink href="https://research.monash.edu/en/projects/heartpath-targeting-self-efficacy-and-health-literacy-through-pat-2">HeartPath+: Targeting self-efficacy and health literacy through patient education to prevent recurrent heart events in Australians with heart disease.</MyLink> in collaboration with <MyLink href="https://research.monash.edu/en/persons/susie-cartledge">Dr. Susie Cartledge</MyLink>, Nov, 2023 - Oct, 2026.</MyLi>                                  
                            <MyLi>IT Team Associate Supervisor, A$15,000 by RAIL Early to Mid Career Researcher (EMCR), <MyLink href="https://connectcr.github.io/#/about">CONNECT-CR: Increasing uptake of cardiac rehabilitation through improving recommendation, referral and continuity of care for cardiac patients and families in Victoria.</MyLink> in collaboration with <MyLink href="https://research.monash.edu/en/persons/susie-cartledge">Dr. Susie Cartledge</MyLink>, and <MyLink href="https://lilicoding.github.io/">Prof. Li Li</MyLink> Feb, 2022 - Feb, 2023.</MyLi>                                                                                                                      
                            <MyLi>Prototype Developer Leader (sole), A$2,000,000 by Digital Health Cooperative Research Centre (DHCRC), <MyLink href="https://research.monash.edu/en/projects/dhcrc-0158-enhanced-telehealth-capabilities">DHCRC 0158: Enhanced Telehealth Capabilities: Enhanced Telehealth Capabilities for Improved Patient and Clinician Experiences.</MyLink> in collaboration with <MyLink href="https://lilicoding.github.io/">Prof. Li Li</MyLink> and <MyLink href="https://www.newcastle.edu.au/profile/xiao-chen">Dr. Xiao Chen</MyLink>, Jun, 2020 - Mar, 2022.</MyLi>                                                         
                        </ul>
                            <Typography align="justify" style={{ fontWeight: 500, fontSize: "14px" }}>
                            * Several projects that remain unlisted due to expired links. In particular, I worked as Research Fellow at Australian National University, leading the innovation of cutting-edge LLM agent that bridge AI and Software Engineering.                                                         
                            </Typography>

                        <Typography style={{ fontWeight: 700, fontSize: "18px", paddingLeft:"0px", fontFamily: '-apple-system' }}>Sole Projects</Typography>
                        <ul style={{ padding: "0px 0 0 30px",  margin:"0px" }}>
                            <MyLi>Visiting Scholarship by <MyLink href="http://www.mysmu.edu/faculty/davidlo/">Prof. David Lo</MyLink>.</MyLi>                                                                                                                                                  
                            <MyLi>Visiting Scholarship by <MyLink href="https://jacquesklein2302.github.io/">Prof. Jacques Klein</MyLink>, and <MyLink href="https://bissyande.github.io/">Prof. Tegawendé F. Bissyandé</MyLink>.</MyLi>                                                                                                                                                  
                            <MyLi>Monash FIT GR travel grant, Monash University</MyLi>                                  
                            <MyLi>Monash HDR Full Scholarship, Monash University and <MyLink href="https://dataportal.arc.gov.au/NCGP/Web/Grant/Grant/FL190100035">Prof. John Grundy's Australian Laureate Fellowships</MyLink>.</MyLi>                                                                                                                      
                            <MyLi>Monash Summer Vacation Research Scholarship, Monash University</MyLi>                                                                                                                                                  
                        </ul> 
                        <Typography align="justify" style={{ fontWeight: 500, fontSize: "14px" }}>
                        * Please contact me if you would like to discuss possible consultancy. I do all of my consultancy and management work as a staff member of Monash University via University contracting and billing. It also has to fit with my primary commitments to the University.                            
                        </Typography>
                </Grid>   

                {/* Experience */}
                {/* <Divider sx={{        
                    background: 'linear-gradient(5deg, transparent, darkslategray, transparent)',
                    height: '5px',
                    maxWidth: '100%',                     
                    width: "100%",
                    border: 'none'
                }} />                 */}
                <Grid  xs={12} item  style={{ padding: "0px", 
                    background:"rgba(238, 238, 238, 0.5)"
                }} >                
                    <Typography style={{ fontWeight: 900, fontSize: "22px", fontFamily: 'Courier' }}> Experience </Typography>                    
                        <ul style={{ padding: "0px 0 0 30px",  margin:"0px" }}>
                            <MyLi>Visiting Scholar at <MyLink href="https://soarsmu.github.io/">SOAR lab</MyLink>, Singapore Management University, Singapore. Sep, 2024 - Mar, 2025.</MyLi>                                  
                            <MyLi>Visiting Scholar at <MyLink href="https://trux-dtf.github.io/">TruX research group </MyLink>, University of Luxembourg, Luxembourg. May, 2024 - Aug, 2024.</MyLi>                                  
                            <MyLi>Ph.D. at <MyLink href="https://www.monash.edu/it/humanise-lab">HumaniSE lab</MyLink>, Monash University, Melbourne, Australia. Jul, 2022 - Apr, 2025. (Transited from MPhil.)</MyLi>                                  
                            <MyLi>MPhil. at <MyLink href="https://smat-lab.github.io/">SMAT lab</MyLink>, Monash University, Melbourne, Australia. Jul, 2021 - Jul, 2022. (Transited to Ph.D.)</MyLi>                                  
                            <MyLi>B.Eng. (Honours) at <MyLink href="https://smat-lab.github.io/">SMAT lab</MyLink>, Monash University, Melbourne, Australia. July, 2017 - Dec, 2020. (4-year Bachelor accelerated in 3.5 years)</MyLi>     
                        </ul>
                </Grid>   
                         
            </Grid>
         </Grid>
    );
}

function LatestNewsLine(props) {
    return (
        <Grid xs={12} item container style={{ paddingBottom: "10px" }} >
            <Typography align="justify" > {props.dateTime && <b>[{props.dateTime}]</b>} {props.children}</Typography>
        </Grid>
    )
}
